import { Link } from "react-router-dom";

function NoAccess({ type = "403" }) {
  const isNoAccess = type === "403";
  const iconSrc = isNoAccess
    ? `${process.env.PUBLIC_URL}/redesign/logos/icon/mindGAME Tree Logo.png`
    : `${process.env.PUBLIC_URL}/brand/mindgame/mindGAME-icon-color-ring-animated.svg`;

  return (
    <div style={containerStyle}>
      <div style={numberWrapperStyle}>
        <h1 style={numberStyle}>4</h1>
        <img src={iconSrc} alt="" aria-hidden="true" style={imageStyle} />
        <h1 style={numberStyle}>{isNoAccess ? "3" : "4"}</h1>
      </div>

      <h1 style={titleStyle}>{isNoAccess ? "Forbidden" : "Page Not Found"}</h1>
      <p style={textStyle}>
        {isNoAccess
          ? "Looks like you're not authorized to access this page"
          : "You took a wrong turn. Check that URL before you blame us."}
      </p>
      <Link to={isNoAccess ? "/steam" : "/login?menu=1"} style={linkStyle}>
        {isNoAccess ? "Go to Steam" : "Return Home"}
      </Link>
    </div>
  );
}

const containerStyle = {
  height: "calc(var(--mg-vh) * 70)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  color: "#fff",
  textAlign: "center",
  padding: 20,
};

const numberWrapperStyle = {
  display: "flex",
  alignItems: "center",
  gap: 5,
};

const numberStyle = {
  margin: 0,
  fontSize: "90px",
};

const imageStyle = {
  width: 100,
  height: 100,
};

const titleStyle = {
  fontSize: 28,
  marginBottom: 16,
  color: "#fff",
};

const textStyle = {
  fontSize: 16,
  color: "#ccc",
  marginBottom: 30,
  maxWidth: 500,
};

const linkStyle = {
  padding: "12px 24px",
  background: "#3fa9f5",
  color: "#000",
  textDecoration: "none",
  borderRadius: 6,
  fontWeight: "bold",
  fontSize: 16,
};

export default NoAccess;
